!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():e.storeblocks=r()}(self,(()=>(()=>{"use strict";var e={279:(e,r,o)=>{o.d(r,{Additions:()=>d,Container:()=>l,InputBase:()=>i,Label:()=>a,NativeInput:()=>s,Suffix:()=>c});const t=require("styled-components");var n=o.n(t);const i=n().div.attrs({className:"input"})`
  display: inline-flex;
  flex-direction: column;
  position: relative;

  color: var(--color-on-background);
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 24px;

  &[aria-disabled='true'] {
    color: var(--color-disabled);
  }

  ${({$fluid:e})=>e&&t.css`
      width: 100%;
      max-width: 100%;

      & > ${l} {
        width: 100%;

        & > select {
          width: 100%;
        }
      }
    `}

  & > .hint {
    margin: -8px 0 16px 0;
  }
`,a=n().label`
  align-items: flex-start;
  display: flex;
  font-weight: 600;
  margin-bottom: 16px;
  word-wrap: break-word;

  > * {
    height: 24px;
  }
`,s=n().input`
  width: 100%;
  height: 40px;
  padding: 0 8px;
  border: none;
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: var(--color-on-background);
  /* hide arrows on input type number start*/
  /* Chrome, Safari */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--color-on-primary);
    caret-color: var(--color-disabled);
    color: var(--color-disabled);
  }

  ${({as:e})=>"textarea"===e&&t.css`
      height: auto;
      padding: 8px;
    `}
`,l=n().div`
  display: flex;
  align-items: center;
  align-self: flex-start;
  border-radius: 2px;
  border: 1px solid var(--color-on-background);
  background-color: var(--color-background);
  box-sizing: border-box;

  cursor: text;

  &:focus-within {
    border: 1px solid var(--color-selection);
    outline: 1px solid var(--color-selection);
  }

  ${({$disabled:e})=>e&&t.css`
      color: var(--color-disabled);
      border: 1px solid var(--color-disabled);
      cursor: not-allowed;
    `}

  ${({$small:e,$large:r,$fluid:o})=>e?t.css`
        width: 96px;
      `:r?t.css`
        width: 288px;
      `:o?t.css`
        width: 100%;
      `:t.css`
      width: 148px;
    `}

  ${({$readOnly:e})=>e&&t.css`
      &:focus-within {
        outline: none;
      }
    `}

  ${({$success:e,$warning:r,$error:o})=>e?t.css`
        outline: 2px solid var(--color-success-accent);
        border: 1px solid var(--color-success-accent);
      `:r?t.css`
        outline: 2px solid var(--color-warning-accent);
        border: 1px solid var(--color-warning-accent);
      `:o?t.css`
        outline: 2px solid var(--color-error-accent);
        border: 1px solid var(--color-error-accent);
      `:""}
`,c=n().div`
  pointer-events: none;
  margin-right: 8px;
  white-space: nowrap;
`,d=n().div`
  display: flex;
  align-items: center;

  z-index: 1;

  > .icon-button {
    margin: 0 16px 0 8px;
  }
`}},r={};function o(t){var n=r[t];if(void 0!==n)return n.exports;var i=r[t]={exports:{}};return e[t](i,i.exports,o),i.exports}o.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return o.d(r,{a:r}),r},o.d=(e,r)=>{for(var t in r)o.o(r,t)&&!o.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:r[t]})},o.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var t={};return(()=>{o.r(t),o.d(t,{Input:()=>p,default:()=>b});const e=require("react");var r=o.n(e);const n=require("@storeblocks/button");var i=o.n(n);const a=require("@storeblocks/inline-alert");var s=o.n(a);const l=require("@storeblocks/hint");var c=o.n(l),d=o(279);const u=e=>"string"==typeof e&&e.length>0;const p=(0,e.forwardRef)(((e,o)=>{var{id:t,name:n,label:a,hint:l,small:p,medium:b=!0,large:f,fluid:x,disabled:g,readOnly:v,trackid:m,success:h,error:y,warning:w,onChange:$,value:O,icon:k,onIconClick:P,iconButtonProps:j,suffix:S,type:E="text",rows:C=6,as:I="input",labelProps:z,hintProps:q,inputProps:B,suffixProps:N,attentionProps:_,labelPopover:F}=e,L=function(e,r){var o={};for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(t=Object.getOwnPropertySymbols(e);n<t.length;n++)r.indexOf(t[n])<0&&Object.prototype.propertyIsEnumerable.call(e,t[n])&&(o[t[n]]=e[t[n]])}return o}(e,["id","name","label","hint","small","medium","large","fluid","disabled","readOnly","trackid","success","error","warning","onChange","value","icon","onIconClick","iconButtonProps","suffix","type","rows","as","labelProps","hintProps","inputProps","suffixProps","attentionProps","labelPopover"]);const M=`${t}-input-label`,A=`${t}-input-suffix`,T=(null==q?void 0:q.id)||`${t}-input-hint`,R=`${t}-input-attention`,D=(({error:e,warning:r,success:o})=>u(e)?"error":u(r)?"warning":u(o)?"success":null)({error:y,warning:w,success:h}),G=((e,r)=>r?e[r]:null)({error:y,warning:w,success:h},D),H=null!==D;return r().createElement(d.InputBase,Object.assign({"aria-disabled":g,$fluid:x},L),a&&r().createElement(d.Label,Object.assign({id:M,htmlFor:t},z),a,!!F&&F),l&&r().createElement(c(),Object.assign({id:T},q),l),r().createElement(d.Container,{$readOnly:v,$small:p,$medium:b,$large:f,$fluid:x,$disabled:g,$success:h,$warning:w,$error:y},r().createElement(d.NativeInput,Object.assign({id:t,as:I,name:n,type:E,"data-trackid":m,"aria-invalid":!!y,"aria-labelledby":`${M} ${A}`,"aria-describedby":`${T} ${R}`,onChange:$,value:O,rows:C,readOnly:v,disabled:g,ref:o},B)),r().createElement(d.Additions,null,S&&r().createElement(d.Suffix,Object.assign({"aria-hidden":"true",id:A},N),S),k&&r().createElement(i(),Object.assign({variant:"icon",iconLeft:k,className:"icon-button",onClick:P,disabled:g||v||!1,color:"on-background","aria-label":k},j)))),H&&r().createElement(s(),Object.assign({variant:D,title:G,id:R,role:y?"alert":"status"},_)))})),b=p})(),t})()));
//# sourceMappingURL=index.js.map